import classNames from "classnames";
import styles from "./Button.module.scss";

type Props = {
  onClick?: (event: React.MouseEvent) => void,
  label: any,
  isPrimary: boolean,
  isActive: boolean
  isSmaller?: boolean
}

export default function Button({ onClick, label, isPrimary, isActive, isSmaller }: Props) {
  return <button onClick={onClick} className={classNames({
    [styles.Button]: true,
    [styles.Primary]: isPrimary,
    [styles.IsActive]: isActive,
    [styles.IsSmaller]: isSmaller
  })}>{label}</button>;
}
